export const STATE_PROP = 'cleaningReports';

export const DATA_EXPORT_FILTER = {
  ALL: 'ALL',
  CONDITION: 'CONDITION'
};

export const MAPPING_TITLE_LNG_BY_FILTER = {
  [DATA_EXPORT_FILTER.ALL]: 'exportCleaningReport.exportAllData',
  [DATA_EXPORT_FILTER.CONDITION]: 'exportCleaningReport.exportFilteredData'
};
